// Traduções deste componente — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'protheus.syncButton.tooltip': 'Sincronizar com o Protheus agora',
    'protheus.syncButton.tooltipPeriodo': 'Sincronizar com o Protheus o período que está na tela',
    'protheus.syncButton.running': 'Sincronizando com o Protheus',
    'protheus.syncButton.done': 'Protheus sincronizado. {{detalhe}}',
    'protheus.syncButton.partial': 'Protheus: {{detalhe}}',
    'protheus.syncButton.resumo': '{{entidade}}: {{lidos}} lidos, {{criados}} criados, {{atualizados}} atualizados',
    'protheus.syncButton.entidade.motoristas': 'motoristas',
    'protheus.syncButton.entidade.operadores': 'operadores',
    'protheus.syncButton.entidade.frota': 'frota',
    'protheus.syncButton.entidade.subcontratos': 'subcontratos',
    'protheus.syncButton.entidade.planilhas': 'planilhas',
    'protheus.syncButton.entidade.frentes': 'frentes',
    'protheus.syncButton.entidade.viagens': 'viagens',
    'protheus.syncButton.entidade.medicoes': 'medições de colheita',
    'protheus.syncButton.entidade.abastecimentos': 'abastecimentos',
    'protheus.syncButton.entidade.notas_fiscais': 'notas fiscais',
    'protheus.syncButton.entidade.diarias': 'diárias',
    'protheus.syncButton.emAndamentoTitulo': 'Sincronização em andamento',
    'protheus.syncButton.emAndamentoSemDetalhe': 'Já existe uma sincronização com o Protheus em andamento.',
    'protheus.syncButton.emAndamentoTexto': 'Aguarde o ciclo terminar ou cancele. Cancelar interrompe o cadastro em leitura na próxima chamada ao ERP, desfaz o que ele ainda não gravou e não inicia os seguintes. O que já foi gravado fica.',
    'protheus.syncButton.cancelar': 'Cancelar sincronização',
    'protheus.syncButton.cancelando': 'Cancelando…',
    'protheus.syncButton.cancelado': 'Cancelamento pedido. O ciclo para na próxima chamada ao Protheus.',
    'protheus.syncButton.semResultado': 'A sincronização com o Protheus terminou, mas o resultado não chegou à tela. A grade foi atualizada.',
  },
  en: {
    'protheus.syncButton.tooltip': 'Sync with Protheus now',
    'protheus.syncButton.tooltipPeriodo': 'Sync the period shown on screen with Protheus',
    'protheus.syncButton.running': 'Syncing with Protheus',
    'protheus.syncButton.done': 'Protheus synced. {{detalhe}}',
    'protheus.syncButton.partial': 'Protheus: {{detalhe}}',
    'protheus.syncButton.resumo': '{{entidade}}: {{lidos}} read, {{criados}} created, {{atualizados}} updated',
    'protheus.syncButton.entidade.motoristas': 'drivers',
    'protheus.syncButton.entidade.operadores': 'operators',
    'protheus.syncButton.entidade.frota': 'fleet',
    'protheus.syncButton.entidade.subcontratos': 'subcontracts',
    'protheus.syncButton.entidade.planilhas': 'field sheets',
    'protheus.syncButton.entidade.frentes': 'work fronts',
    'protheus.syncButton.entidade.viagens': 'trips',
    'protheus.syncButton.entidade.medicoes': 'harvest measurements',
    'protheus.syncButton.entidade.abastecimentos': 'refuelings',
    'protheus.syncButton.entidade.notas_fiscais': 'invoices',
    'protheus.syncButton.entidade.diarias': 'daily allowances',
    'protheus.syncButton.emAndamentoTitulo': 'Sync in progress',
    'protheus.syncButton.emAndamentoSemDetalhe': 'A Protheus sync is already in progress.',
    'protheus.syncButton.emAndamentoTexto': 'Wait for the cycle to finish or cancel it. Cancelling stops the record being read at the next ERP call, rolls back what it has not saved yet and does not start the next ones. What was already saved stays.',
    'protheus.syncButton.cancelar': 'Cancel sync',
    'protheus.syncButton.cancelando': 'Cancelling…',
    'protheus.syncButton.cancelado': 'Cancellation requested. The cycle stops at the next Protheus call.',
    'protheus.syncButton.semResultado': 'The Protheus sync finished, but its result did not reach the screen. The grid was refreshed.',
  },
  es: {
    'protheus.syncButton.tooltip': 'Sincronizar con Protheus ahora',
    'protheus.syncButton.tooltipPeriodo': 'Sincronizar con Protheus el período que está en pantalla',
    'protheus.syncButton.running': 'Sincronizando con Protheus',
    'protheus.syncButton.done': 'Protheus sincronizado. {{detalhe}}',
    'protheus.syncButton.partial': 'Protheus: {{detalhe}}',
    'protheus.syncButton.resumo': '{{entidade}}: {{lidos}} leídos, {{criados}} creados, {{atualizados}} actualizados',
    'protheus.syncButton.entidade.motoristas': 'conductores',
    'protheus.syncButton.entidade.operadores': 'operadores',
    'protheus.syncButton.entidade.frota': 'flota',
    'protheus.syncButton.entidade.subcontratos': 'subcontratos',
    'protheus.syncButton.entidade.planilhas': 'planillas',
    'protheus.syncButton.entidade.frentes': 'frentes',
    'protheus.syncButton.entidade.viagens': 'viajes',
    'protheus.syncButton.entidade.medicoes': 'mediciones de cosecha',
    'protheus.syncButton.entidade.abastecimentos': 'abastecimientos',
    'protheus.syncButton.entidade.notas_fiscais': 'notas fiscales',
    'protheus.syncButton.entidade.diarias': 'viáticos',
    'protheus.syncButton.emAndamentoTitulo': 'Sincronización en curso',
    'protheus.syncButton.emAndamentoSemDetalhe': 'Ya hay una sincronización con Protheus en curso.',
    'protheus.syncButton.emAndamentoTexto': 'Espera a que el ciclo termine o cancélalo. Cancelar interrumpe el registro en lectura en la próxima llamada al ERP, deshace lo que aún no guardó y no inicia los siguientes. Lo ya guardado permanece.',
    'protheus.syncButton.cancelar': 'Cancelar sincronización',
    'protheus.syncButton.cancelando': 'Cancelando…',
    'protheus.syncButton.cancelado': 'Cancelación solicitada. El ciclo se detiene en la próxima llamada a Protheus.',
    'protheus.syncButton.semResultado': 'La sincronización con Protheus terminó, pero el resultado no llegó a la pantalla. La tabla fue actualizada.',
  },
}
